import DashboardIcon from './images/sidebar-icons/Dashboard.svg';
import AdministrationIcon from './images/sidebar-icons/Administration.svg';
import AdmissionIcon from './images/sidebar-icons/Admission.svg';
import TasksQueueIcon from './images/sidebar-icons/Tasks-Queue.svg';
import DevicesIcon from './images/sidebar-icons/Devices.svg';
import SightingsIcon from './images/sidebar-icons/Sightings.svg';
import ReadersIcon from './images/sidebar-icons/Readers.svg';
import EquipmentIcon from './images/sidebar-icons/Equipment.svg';
import GeofencesIcon from './images/sidebar-icons/Geofences.svg';
import FacilitiesIcon from './images/sidebar-icons/Facilities.svg';
import ScanSessionsIcon from './images/sidebar-icons/Scan-Sessions.svg';
import PairingHistoryIcon from './images/sidebar-icons/Pairing-History.svg';
import CollectionsIcon from './images/sidebar-icons/Collections.svg';
import TransfersIcon from './images/sidebar-icons/Transfers.svg';
import AppReleasesIcon from './images/sidebar-icons/App-Releases.svg';
import DownloadsIcon from './images/sidebar-icons/Downloads.svg';
import VisitsIcon from './images/sidebar-icons/Visits.svg';
import SettingsIcon from './images/sidebar-icons/Settings.svg';
import UserGuideIcon from './images/sidebar-icons/User-Guide.svg';
import UsersIcon from './images/sidebar-icons/Users.svg';
import ContractsIcon from './images/sidebar-icons/Contracts.svg';
import CompaniesIcon from './images/sidebar-icons/Companies.svg';
import PoliciesIcon from './images/sidebar-icons/Policies.svg';
import RolesIcon from './images/sidebar-icons/Roles.svg';
import ScopesIcon from './images/sidebar-icons/Scopes.svg';
import SuperSentinelIcon from './images/sidebar-icons/Super-Sentinel.svg';
import InventoryIcon from './images/sidebar-icons/Inventory.svg';
import LanguagesIcon from './images/sidebar-icons/Languages.svg';
import TemplatesIcon from './images/sidebar-icons/Templates.svg';
import LabelsIcon from './images/sidebar-icons/Labels.svg';
import StockDetailsIcon from './images/sidebar-icons/stock-details.svg';

import DashboardActiveIcon from './images/sidebar-icons/dashboard-active.svg';
import AdministrationActiveIcon from './images/sidebar-icons/administration-active.svg';
import AdmissionActiveIcon from './images/sidebar-icons/admission-active.svg';
import TasksQueueActiveIcon from './images/sidebar-icons/tasks-queue-active.svg';
import DevicesActiveIcon from './images/sidebar-icons/devices-active.svg';
import SightingsActiveIcon from './images/sidebar-icons/sightings-active.svg';
import ReadersActiveIcon from './images/sidebar-icons/readers-active.svg';
import EquipmentActiveIcon from './images/sidebar-icons/equipment-active.svg';
import GeofencesActiveIcon from './images/sidebar-icons/geofences-active.svg';
import FacilitiesActiveIcon from './images/sidebar-icons/facilities-active.svg';
import ScanSessionsActiveIcon from './images/sidebar-icons/scan-sessions-active.svg';
import PairingHistoryActiveIcon from './images/sidebar-icons/pairing-active.svg';
import CollectionsActiveIcon from './images/sidebar-icons/collections-active.svg';
import TransfersActiveIcon from './images/sidebar-icons/transfers-active.svg';
import AppReleasesActiveIcon from './images/sidebar-icons/app-releases-active.svg';
import DownloadsActiveIcon from './images/sidebar-icons/downloads-active.svg';
import VisitsActiveIcon from './images/sidebar-icons/visits-icon-active.svg';
import SettingsActiveIcon from './images/sidebar-icons/settings-active.svg';
import UserGuideActiveIcon from './images/sidebar-icons/user-guide-active.svg';
import UsersActiveIcon from './images/sidebar-icons/users-active.svg';
import ContractsActiveIcon from './images/sidebar-icons/contracts-active.svg';
import CompaniesActiveIcon from './images/sidebar-icons/companies-active.svg';
import PoliciesActiveIcon from './images/sidebar-icons/policies-active.svg';
import RolesActiveIcon from './images/sidebar-icons/roles-active.svg';
import ScopesActiveIcon from './images/sidebar-icons/scopes-active.svg';
import SuperSentinelActiveIcon from './images/sidebar-icons/super-sentinel-active.svg';
import InventoryActiveIcon from './images/sidebar-icons/inventory-active.svg';
import LanguagesActiveIcon from './images/sidebar-icons/language-active.svg';
import TemplatesActiveIcon from './images/sidebar-icons/email-template-active.svg';
import LabelsActiveIcon from './images/sidebar-icons/labels-active.svg';
import StockDetailsActiveIcon from './images/sidebar-icons/stock-details-active.svg';

export const sidebarIcons = {
  dashboard: {
    base: DashboardIcon,
    active: DashboardActiveIcon,
  },
  administration: {
    base: AdministrationIcon,
    active: AdministrationActiveIcon,
  },
  admission: {
    base: AdmissionIcon,
    active: AdmissionActiveIcon,
  },
  'tasks-queue': {
    base: TasksQueueIcon,
    active: TasksQueueActiveIcon,
  },
  devices: {
    base: DevicesIcon,
    active: DevicesActiveIcon,
  },
  sightings: {
    base: SightingsIcon,
    active: SightingsActiveIcon,
  },
  readers: {
    base: ReadersIcon,
    active: ReadersActiveIcon,
  },
  equipment: {
    base: EquipmentIcon,
    active: EquipmentActiveIcon,
  },
  geofences: {
    base: GeofencesIcon,
    active: GeofencesActiveIcon,
  },
  facilities: {
    base: FacilitiesIcon,
    active: FacilitiesActiveIcon,
  },
  'scan-sessions': {
    base: ScanSessionsIcon,
    active: ScanSessionsActiveIcon,
  },
  'pairing-history': {
    base: PairingHistoryIcon,
    active: PairingHistoryActiveIcon,
  },
  collections: {
    base: CollectionsIcon,
    active: CollectionsActiveIcon,
  },
  transfers: {
    base: TransfersIcon,
    active: TransfersActiveIcon,
  },
  'app-releases': {
    base: AppReleasesIcon,
    active: AppReleasesActiveIcon,
  },
  downloads: {
    base: DownloadsIcon,
    active: DownloadsActiveIcon,
  },
  visits: {
    base: VisitsIcon,
    active: VisitsActiveIcon,
  },
  settings: {
    base: SettingsIcon,
    active: SettingsActiveIcon,
  },
  'user-guide': {
    base: UserGuideIcon,
    active: UserGuideActiveIcon,
  },
  users: {
    base: UsersIcon,
    active: UsersActiveIcon,
  },
  contracts: {
    base: ContractsIcon,
    active: ContractsActiveIcon,
  },
  companies: {
    base: CompaniesIcon,
    active: CompaniesActiveIcon,
  },
  policies: {
    base: PoliciesIcon,
    active: PoliciesActiveIcon,
  },
  roles: {
    base: RolesIcon,
    active: RolesActiveIcon,
  },
  scopes: {
    base: ScopesIcon,
    active: ScopesActiveIcon,
  },
  'super-sentinel-activation': {
    base: SuperSentinelIcon,
    active: SuperSentinelActiveIcon,
  },
  inventory: {
    base: InventoryIcon,
    active: InventoryActiveIcon,
  },
  languages: {
    base: LanguagesIcon,
    active: LanguagesActiveIcon,
  },
  templates: {
    base: TemplatesIcon,
    active: TemplatesActiveIcon,
  },
  labels: {
    base: LabelsIcon,
    active: LabelsActiveIcon,
  },
  'stock-details': {
    base: StockDetailsIcon,
    active: StockDetailsActiveIcon,
  },
} as const;

export type SidebarIconKey = keyof typeof sidebarIcons;
